module.exports = __webpack_public_path__ + "static/media/eyeSolidNotif.f8b618b1.svg";